<div class="popup-header head-fixed p-4">
  <div class="header-left">
    <div class="header-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
          d="M15 19c0-2.21-2.686-4-6-4s-6 1.79-6 4m16-3v-3m0 0v-3m0 3h-3m3 0h3M9 12a4 4 0 1 1 0-8a4 4 0 0 1 0 8" />
      </svg>
    </div>
    <div class="header-text">
      <h2 class="header-title">{{ popupTitle }}</h2>
      <p *ngIf="popupSubtitle" class="header-subtitle">{{ popupSubtitle }}</p>
    </div>
  </div>




  <button mat-icon-button class="mat-dialog-close" (click)="closeDialog()">
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24">
      <path fill="currentColor"
        d="m12 12.708l-5.246 5.246q-.14.14-.344.15t-.364-.15t-.16-.354t.16-.354L11.292 12L6.046 6.754q-.14-.14-.15-.344t.15-.364t.354-.16t.354.16L12 11.292l5.246-5.246q.14-.14.345-.15q.203-.01.363.15t.16.354t-.16.354L12.708 12l5.246 5.246q.14.14.15.345q.01.203-.15.363t-.354.16t-.354-.16z" />
    </svg>
  </button>


</div>

<div class="add-applicant-container" [formGroup]="applicantForm">
  <!-- Left Sidebar - Progress Tracker -->
  <div class="sidebar">
    <div class="progress-tracker">
      <div class="steps">
        <div *ngFor="let step of steps; let i = index" class="step-item" [ngClass]="{
            'complete': step.status === 'complete',
            'active': step.status === 'in-progress',
            'pending': step.status === 'pending'
          }" (click)="goToStep(step.id)">

          <div class="step-icon">
            <img [src]="step.icon" [alt]="step.title" class="icon-svg" />
            <div class="status-indicator" *ngIf="step.status === 'complete'">✓</div>
          </div>

          <div class="step-content">
            <div class="step-number">Step {{ step.id }}</div>
            <div class="step-title">{{ step.title }}</div>
            <div class="step-status">{{ step.status === 'complete' ? 'Complete' : step.status === 'in-progress' ? 'In
              progress' : 'Pending' }}</div>
          </div>

          <!-- Progress Line after each step (except the last one) -->
          <div *ngIf="i < steps.length - 1" class="step-progress-line"
            [ngClass]="{'completed': i < currentStep - 1, 'active': i === currentStep - 1, 'pending': i > currentStep - 1}">
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Section - Form Content -->
  <div class="main-content">
    <!-- Navigation Buttons at Top -->


    <!-- Form Content -->
    <div class="form-content">
      <!-- Step 1: Personal Details -->
      <div *ngIf="currentStep === 1" class="animate-slide-right">
        <div class="form-section">
          <h2 class="section-title">Personal Information</h2>

          <div class="form-row">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Surname</mat-label>
              <input type="text" matInput formControlName="surname" placeholder="Enter surname">
              <mat-error *ngIf="applicantForm.get('surname')?.hasError('required')">
                Surname is required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>First Name(s)</mat-label>
              <input type="text" matInput formControlName="firstName" placeholder="Enter first name(s)">
              <mat-error *ngIf="applicantForm.get('firstName')?.hasError('required')">
                First name is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Email</mat-label>
              <input type="text" matInput formControlName="email" placeholder="Enter email">
              <mat-error *ngIf="applicantForm.get('email')?.hasError('required')">
                Surname is required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>ContactPhone</mat-label>
              <input type="number" matInput formControlName="phone" placeholder="Enter phone">
              <mat-error *ngIf="applicantForm.get('firstName')?.hasError('required')">
                First name is required
              </mat-error>
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Address</mat-label>
            <input type="text" matInput formControlName="address" placeholder="Street address">
            <mat-error *ngIf="applicantForm.get('address')?.hasError('required')">
              Address is required
            </mat-error>
          </mat-form-field>

          <div class="form-row">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Postal Code</mat-label>
              <input type="text" matInput formControlName="postalCode" placeholder="Enter postal code">
              <mat-error *ngIf="applicantForm.get('postalCode')?.hasError('required')">
                Postal code is required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>City</mat-label>
              <input type="text" matInput formControlName="city" placeholder="Enter city">
              <mat-error *ngIf="applicantForm.get('city')?.hasError('required')">
                City is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-field">
            <label>Gender</label>
            <mat-radio-group formControlName="gender" class="radio-group">
              <div class="radio-option" (click)="selectRadioOption('gender', 'male')">
                <mat-radio-button value="male">Male</mat-radio-button>
              </div>
              <div class="radio-option" (click)="selectRadioOption('gender', 'female')">
                <mat-radio-button value="female">Female</mat-radio-button>
              </div>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('gender')?.hasError('required') && applicantForm.get('gender')?.touched">
              Gender is required
            </mat-error>
          </div>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Date of Birth</mat-label>
            <input type="text" matInput formControlName="dateOfBirth" placeholder="MM/DD/YYYY">
            <mat-error *ngIf="applicantForm.get('dateOfBirth')?.hasError('required')">
              Date of birth is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>GP Name</mat-label>
            <input type="text" matInput formControlName="gpName" placeholder="Enter GP name">
            <mat-error *ngIf="applicantForm.get('gpName')?.hasError('required')">
              GP name is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Surgery</mat-label>
            <input type="text" matInput formControlName="surgery" placeholder="Enter surgery">
            <mat-error *ngIf="applicantForm.get('surgery')?.hasError('required')">
              Surgery is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Practice Address</mat-label>
            <input type="text" matInput formControlName="practiceAddress" placeholder="Enter practice address">
            <mat-error *ngIf="applicantForm.get('practiceAddress')?.hasError('required')">
              Practice address is required
            </mat-error>
          </mat-form-field>

          <div class="form-row">
            <div class="form-field">
              <label>Height</label>
              <div class="input-with-unit">
                <input type="text" formControlName="height" placeholder="Height" class="form-input">
                <div class="unit-selector">
                  <span class="unit-text">{{ applicantForm.get('heightUnit')?.value || 'CM' }}</span>
                  <mat-select formControlName="heightUnit" class="unit-dropdown">
                    <mat-option value="CM">CM</mat-option>
                    <mat-option value="FT">FT</mat-option>
                  </mat-select>
                </div>
              </div>
              <mat-error
                *ngIf="applicantForm.get('height')?.hasError('required') && applicantForm.get('height')?.touched">
                Height is required
              </mat-error>
            </div>

            <div class="form-field">
              <label>Weight</label>
              <div class="input-with-unit">
                <input type="text" formControlName="weight" placeholder="Weight" class="form-input">
                <div class="unit-selector">
                  <span class="unit-text">{{ applicantForm.get('weightUnit')?.value || 'KG' }}</span>
                  <mat-select formControlName="weightUnit" class="unit-dropdown">
                    <mat-option value="KG">KG</mat-option>
                    <mat-option value="LBS">LBS</mat-option>
                  </mat-select>
                </div>
              </div>
              <mat-error
                *ngIf="applicantForm.get('weight')?.hasError('required') && applicantForm.get('weight')?.touched">
                Weight is required
              </mat-error>
            </div>
          </div>

          <div class="form-field">
            <label>{{ allQuestions?.[2]?.questionText || 'Have you experienced any weight loss?' }}</label>
            <mat-radio-group formControlName="weightLoss" class="radio-group">
              <div class="radio-option" (click)="selectRadioOption('weightLoss', 'yes')">
                <mat-radio-button value="yes">Yes</mat-radio-button>
              </div>
              <div class="radio-option" (click)="selectRadioOption('weightLoss', 'no')">
                <mat-radio-button value="no">No</mat-radio-button>
              </div>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('weightLoss')?.hasError('required') && applicantForm.get('weightLoss')?.touched">
              This field is required
            </mat-error>
          </div>

          <mat-form-field appearance="outline" class="form-field"
            *ngIf="applicantForm.get('weightLoss')?.value === 'yes'" style="height: 75px;">
            <mat-label>Cause of Weight Loss</mat-label>
            <textarea matInput formControlName="weightLossCause" placeholder="Cause"></textarea>
          </mat-form-field>

          <div class="form-field">
            <label>{{ allQuestions?.[3]?.questionText || 'Do you smoke?' }}</label>
            <mat-radio-group formControlName="smoking" class="radio-group">
              <div class="radio-option" (click)="selectRadioOption('smoking', 'yes')">
                <mat-radio-button value="yes">Yes</mat-radio-button>
              </div>
              <div class="radio-option" (click)="selectRadioOption('smoking', 'no')">
                <mat-radio-button value="no">No</mat-radio-button>
              </div>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('smoking')?.hasError('required') && applicantForm.get('smoking')?.touched">
              This field is required
            </mat-error>
          </div>

          <div class="form-field">
            <label>{{ allQuestions?.[4]?.questionText || 'Do you consume alcohol?' }}</label>
            <mat-radio-group formControlName="alcohol" class="radio-group">
              <div class="radio-option" (click)="selectRadioOption('alcohol', 'yes')">
                <mat-radio-button value="yes">Yes</mat-radio-button>
              </div>
              <div class="radio-option" (click)="selectRadioOption('alcohol', 'no')">
                <mat-radio-button value="no">No</mat-radio-button>
              </div>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('alcohol')?.hasError('required') && applicantForm.get('alcohol')?.touched">
              This field is required
            </mat-error>
          </div>

          <div class="form-field">
            <label>{{ allQuestions?.[5]?.questionText || 'Have you had periods of heavy alcohol consumption?' }}</label>
            <mat-radio-group formControlName="alcoholPeriod" class="radio-group">
              <div class="radio-option" (click)="selectRadioOption('alcoholPeriod', 'yes')">
                <mat-radio-button value="yes">Yes</mat-radio-button>
              </div>
              <div class="radio-option" (click)="selectRadioOption('alcoholPeriod', 'no')">
                <mat-radio-button value="no">No</mat-radio-button>
              </div>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('alcoholPeriod')?.hasError('required') && applicantForm.get('alcoholPeriod')?.touched">
              This field is required
            </mat-error>
          </div>

          <mat-form-field appearance="outline" class="form-field"
            *ngIf="applicantForm.get('alcoholPeriod')?.value === 'yes'">
            <mat-label>Period Details</mat-label>
            <input type="text" matInput formControlName="alcoholPeriodDetails" placeholder="Period">
          </mat-form-field>

          <div class="form-field">
            <label>{{ allQuestions?.[6]?.questionText || 'Have you ever used drugs?' }}</label>
            <mat-radio-group formControlName="drugs" class="radio-group">
              <div class="radio-option" (click)="selectRadioOption('drugs', 'yes')">
                <mat-radio-button value="yes">Yes</mat-radio-button>
              </div>
              <div class="radio-option" (click)="selectRadioOption('drugs', 'no')">
                <mat-radio-button value="no">No</mat-radio-button>
              </div>
            </mat-radio-group>
            <mat-error *ngIf="applicantForm.get('drugs')?.hasError('required') && applicantForm.get('drugs')?.touched">
              This field is required
            </mat-error>
          </div>

          <div class="form-field">
            <label>{{ allQuestions?.[7]?.questionText || 'Have you ever used drugs in the past?' }}</label>
            <mat-radio-group formControlName="drugsPast" class="radio-group">
              <div class="radio-option" (click)="selectRadioOption('drugsPast', 'yes')">
                <mat-radio-button value="yes">Yes</mat-radio-button>
              </div>
              <div class="radio-option" (click)="selectRadioOption('drugsPast', 'no')">
                <mat-radio-button value="no">No</mat-radio-button>
              </div>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('drugsPast')?.hasError('required') && applicantForm.get('drugsPast')?.touched">
              This field is required
            </mat-error>
          </div>

        </div>
      </div>

      <!-- Step 2: Health Questions -->
      <div *ngIf="currentStep === 2" class="animate-slide-right">
        <div class="form-section">
          <h2 class="section-title">Additional Health Questions</h2>

          <!-- Additional Health Questions -->
          <div class="form-field">
            <label>{{ allQuestions?.[8]?.questionText || 'Do you have any medical conditions?' }}</label>
            <mat-radio-group formControlName="medicalConditions" class="radio-group">
              <div class="radio-option" (click)="selectRadioOption('medicalConditions', 'yes')">
                <mat-radio-button value="yes">Yes</mat-radio-button>
              </div>
              <div class="radio-option" (click)="selectRadioOption('medicalConditions', 'no')">
                <mat-radio-button value="no">No</mat-radio-button>
              </div>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('medicalConditions')?.hasError('required') && applicantForm.get('medicalConditions')?.touched">
              This field is required
            </mat-error>
          </div>

          <div class="form-field">
            <label>{{ allQuestions?.[9]?.questionText || 'Have you consulted any healthcare professionals?' }}</label>
            <mat-radio-group formControlName="medications" class="radio-group">
              <div class="radio-option" (click)="selectRadioOption('medications', 'All')">
                <mat-radio-button value="All">physiotherapist,manual therapist,chiropractor or
                  practioner of an alternative medicine,e.g.homeopath or acupuncturist?</mat-radio-button>
              </div>
              <div class="yes-no-container">
                <div class="radio-option" (click)="selectRadioOption('medications', 'yes')">
                  <mat-radio-button value="yes">Yes</mat-radio-button>
                </div>
                <div class="radio-option" (click)="selectRadioOption('medications', 'no')">
                  <mat-radio-button value="no">No</mat-radio-button>
                </div>
              </div>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('medications')?.hasError('required') && applicantForm.get('medications')?.touched">
              This field is required
            </mat-error>
          </div>


          <div class="form-field">
            <label>{{ allQuestions?.[10]?.questionText || 'Have you had any surgeries?' }}</label>
            <mat-radio-group formControlName="surgeries" class="radio-group">
              <mat-radio-button value="yes" class="radio-option">Yes</mat-radio-button>
              <mat-radio-button value="no" class="radio-option">No</mat-radio-button>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('surgeries')?.hasError('required') && applicantForm.get('surgeries')?.touched">
              This field is required
            </mat-error>
          </div>

          <div class="form-field">
            <label>{{ allQuestions?.[11]?.questionText || 'Do you have a family history of medical conditions?'
              }}</label>
            <mat-radio-group formControlName="familyHistory" class="radio-group">
              <mat-radio-button value="yes" class="radio-option">Yes</mat-radio-button>
              <mat-radio-button value="no" class="radio-option">No</mat-radio-button>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('familyHistory')?.hasError('required') && applicantForm.get('familyHistory')?.touched">
              This field is required
            </mat-error>
          </div>

          <div class="form-field">
            <label>{{ allQuestions?.[12]?.questionText || 'Have you been hospitalized?' }}</label>
            <mat-radio-group formControlName="hospitalized" class="radio-group">
              <mat-radio-button value="yes" class="radio-option">Yes</mat-radio-button>
              <mat-radio-button value="no" class="radio-option">No</mat-radio-button>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('hospitalized')?.hasError('required') && applicantForm.get('hospitalized')?.touched">
              This field is required
            </mat-error>
          </div>

          <div class="form-field">
            <label>{{ allQuestions?.[13]?.questionText || 'Have you had surgery?' }}</label>
            <mat-radio-group formControlName="Surgey" class="radio-group">
              <mat-radio-button value="yes" class="radio-option">Yes</mat-radio-button>
              <mat-radio-button value="no" class="radio-option">No</mat-radio-button>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('Surgey')?.hasError('required') && applicantForm.get('Surgey')?.touched">
              This field is required
            </mat-error>
          </div>

          <div class="form-field">
            <label>{{ allQuestions?.[14]?.questionText || 'Have you visited a GP recently?' }}</label>
            <mat-radio-group formControlName="visitedGp" class="radio-group">
              <mat-radio-button value="yes" class="radio-option">Yes</mat-radio-button>
              <mat-radio-button value="no" class="radio-option">No</mat-radio-button>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('visitedGp')?.hasError('required') && applicantForm.get('visitedGp')?.touched">
              This field is required
            </mat-error>
          </div>

          <div class="form-field">
            <label>{{ allQuestions?.[15]?.questionText || 'Have you had an MRI scan?' }}</label>
            <mat-radio-group formControlName="MRI" class="radio-group">
              <mat-radio-button value="yes" class="radio-option">Yes</mat-radio-button>
              <mat-radio-button value="no" class="radio-option">No</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="applicantForm.get('MRI')?.hasError('required') && applicantForm.get('MRI')?.touched">
              This field is required
            </mat-error>
          </div>

          <div class="form-field">
            <label>{{ allQuestions?.[16]?.questionText || 'Have you had blood tests?' }}</label>
            <mat-radio-group formControlName="Blood" class="radio-group">
              <mat-radio-button value="yes" class="radio-option">Yes</mat-radio-button>
              <mat-radio-button value="no" class="radio-option">No</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="applicantForm.get('Blood')?.hasError('Blood') && applicantForm.get('Blood')?.touched">
              This field is required
            </mat-error>
          </div>

          <h2 class="section-title">Annex to section 3. Your health</h2>

          <mat-form-field appearance="outline" class="form-field" style="height: 75px;">
            <mat-label>{{ allQuestions?.[17]?.questionText || 'Describe your complaint or illness' }}</mat-label>
            <textarea matInput formControlName="ComplaintIllness" placeholder="ComplaintIllness"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field" style="height: 75px;">
            <mat-label>{{ allQuestions?.[18]?.questionText || 'What caused your complaint or illness?' }}</mat-label>
            <textarea matInput formControlName="ComplaintIllnessCause" placeholder="ComplaintIllnessCause"></textarea>
          </mat-form-field>

          <div class="form-field">
            <label>{{ allQuestions?.[19]?.questionText || 'Do you still have this complaint?' }}</label>
            <mat-radio-group formControlName="StillComplaint" class="radio-group">
              <mat-radio-button value="yes" class="radio-option">Yes</mat-radio-button>
              <mat-radio-button value="no" class="radio-option">No</mat-radio-button>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('StillComplaint')?.hasError('required') && applicantForm.get('StillComplaint')?.touched">
              This field is required
            </mat-error>
          </div>

          <mat-form-field appearance="outline" class="form-field" style="height: 75px;">
            <mat-label>Namely</mat-label>
            <textarea matInput formControlName="weightLossCause" placeholder="Cause"></textarea>
          </mat-form-field>

          <h2 class="section-title">Doctor or health professional </h2>

          <div class="form-field">
            <label>{{ allQuestions?.[20]?.questionText || 'Have you ever been to a doctor for this condition?'
              }}</label>
            <mat-radio-group formControlName="everBeenDoctor" class="radio-group">
              <mat-radio-button value="yes" class="radio-option">Yes</mat-radio-button>
              <mat-radio-button value="no" class="radio-option">No</mat-radio-button>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('everBeenDoctor')?.hasError('required') && applicantForm.get('everBeenDoctor')?.touched">
              This field is required
            </mat-error>
          </div>

          <div class="form-field">
            <label>{{ allQuestions?.[21]?.questionText || 'Did a doctor prescribe medication for this condition?'
              }}</label>
            <mat-radio-group formControlName="doctorPrescribe" class="radio-group">
              <mat-radio-button value="yes" class="radio-option">Yes</mat-radio-button>
              <mat-radio-button value="no" class="radio-option">No</mat-radio-button>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('doctorPrescribe')?.hasError('required') && applicantForm.get('doctorPrescribe')?.touched">
              This field is required
            </mat-error>
          </div>

          <div class="form-field">
            <label>For this complaint,illness or condition,were you (have you been) admitted to a:hospital, mental
              institution or other institution?</label>
            <mat-radio-group formControlName="admitHospital" class="radio-group">
              <mat-radio-button value="yes" class="radio-option">Yes</mat-radio-button>
              <mat-radio-button value="no" class="radio-option">No</mat-radio-button>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('admitHospital')?.hasError('required') && applicantForm.get('admitHospital')?.touched">
              This field is required
            </mat-error>
          </div>

          <div class="form-field">
            <label>Have you had surgery?</label>
            <mat-radio-group formControlName="exercise" class="radio-group">
              <mat-radio-button value="yes" class="radio-option">Yes</mat-radio-button>
              <mat-radio-button value="no" class="radio-option">No</mat-radio-button>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('exercise')?.hasError('required') && applicantForm.get('exercise')?.touched">
              This field is required
            </mat-error>
          </div>

          <div class="form-field">
            <label>Did you not work for two consectutive weeks or more because of this? Or worked only part of the
              day?</label>
            <mat-radio-group formControlName="exercise" class="radio-group">
              <mat-radio-button value="yes" class="radio-option">Yes</mat-radio-button>
              <mat-radio-button value="no" class="radio-option">No</mat-radio-button>
            </mat-radio-group>
            <mat-error
              *ngIf="applicantForm.get('exercise')?.hasError('required') && applicantForm.get('exercise')?.touched">
              This field is required
            </mat-error>
          </div>

        </div>
      </div>

      <!-- Step 3: Quote -->
      <div *ngIf="currentStep === 3" class="animate-slide-right">
        <div class="form-section">
          <h2 class="section-title">Tell us your preferred insurance amount</h2>

          <label>Select the coverage amount:</label>
          <div class="slider-container">
            <mat-slider #coverageSlider class="sum-assured-slider" min="5000" max="1000000" step="10000" discrete  value=200000
              [displayWith]="formatLabel">
              <input matSliderThumb formControlName="coverageAmount" />
            </mat-slider>

            <p class="value-display">
              Coverage selected: £{{ applicantForm.get('coverageAmount')?.value | number:'1.0-0':'en-GB' }}
            </p>
          </div>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Term in years</mat-label>
            <mat-select formControlName="policyType" >
              <mat-option value="1">1</mat-option>
              <mat-option value="2">2</mat-option>
              <mat-option value="3">3</mat-option>
              <mat-option value="4">4</mat-option>
              <mat-option value="5">5</mat-option>
              <mat-option value="6">6</mat-option>
              <mat-option value="7">7</mat-option>
              <mat-option value="8">8</mat-option>
              <mat-option value="9">9</mat-option>
              <mat-option value="10">10</mat-option>
                <mat-option value="11">11</mat-option>
                 <mat-option value="12">12</mat-option>
                  <mat-option value="13">13</mat-option>
                   <mat-option value="14">14</mat-option>
                    <mat-option value="15">15</mat-option>
                     <mat-option value="16">16</mat-option>
                      <mat-option value="17">17</mat-option>
                       <mat-option value="18">18</mat-option>
                        <mat-option value="19">19</mat-option>
                         <mat-option value="20">20</mat-option>
                           <mat-option value="21">21</mat-option>
                             <mat-option value="22">22</mat-option>  
                             <mat-option value="23">23</mat-option>
                               <mat-option value="24">24</mat-option>
                                 <mat-option value="25">25</mat-option>
                                   <mat-option value="26">26</mat-option>
                                     <mat-option value="27">27</mat-option>
                                       <mat-option value="28">28</mat-option>
                                         <mat-option value="29">29</mat-option>
                                           <mat-option value="30">30</mat-option>
            </mat-select>
            <mat-error
              *ngIf="applicantForm.get('policyType')?.hasError('required') && applicantForm.get('policyType')?.touched">
              Term is required
            </mat-error>
          </mat-form-field>

          <div class="form-actions">
            <button class="primaryBtn"
              [disabled]="applicantForm.get('policyType')?.hasError('required') || applicantForm.get('policyType')?.hasError('required')"
              (click)="getQuote()">Get Quote</button>
          </div>

          <!-- Quote Details (shown after clicking Get Quote) -->
          <div *ngIf="showQuoteDetails" class="quote-details">
            <h3 class="quote-title">Cover Quote for Applicant</h3>

            <div class="quote-section">
              <h4 class="section-heading">Customer Needs</h4>
              <div class="quote-item">
                <span class="label">Package Name:</span>
                <span class="value"> HPS Life</span>
              </div>
              <div class="quote-item">
                <span class="label">Insurer:</span>
                <span class="value">
                  <img src="../../../../../../assets/gifs/onefam.png" alt="Insurance Logo" width="100" height="30" />
                </span>
              </div>
              <div class="quote-item">
                <span class="label">Effective Date:</span>
                <span class="value">Sept 15, 2025</span>
              </div>
            </div>

            <div class="quote-section">
              <h4 class="section-heading">Coverage Details</h4>
              <div class="quote-item">
                <span class="label">Sum Insured:</span>
                <span class="value">£{{ applicantForm.get('coverageAmount')?.value | number:'1.0-0':'en-GB' }}</span>
              </div>
              <div class="quote-item">
                <span class="label">Term:</span>
                <span class="value">{{ applicantForm.get('policyType')?.value}} year</span>
              </div>
            </div>

            <div class="quote-section">
              <h4 class="section-heading">Pricing</h4>
              <div class="quote-item">
                <span class="label">Monthly Premium:</span>
                <span class="value">£{{ monthlyPremium | number:'1.2-2' }}</span>
              </div>
              <div class="quote-item">
                <span class="label">Total Annual Cost:</span>
                <span class="value">£{{ totalAnnualCost | number:'1.2-2' }}</span>
              </div>
               <!-- div  class="quote-item" >
                  <span class="label">Total Premium to be paid:</span>
                 <span class="value">£{{ totalPremiumtobepaid | number:'1.2-2' }}</span>
                 </div -->
            </div>
          </div>

        </div>
      </div>

      <!-- Step 4: Consent -->
      <div *ngIf="currentStep === 4" class="animate-slide-right">
        <div class="form-section">
          <h2 class="section-title">Consent</h2>

          <p>I consent on the behalf of Sarah Miller</p>

          <div class="form-field" style="margin-bottom: 20px;">
            <mat-checkbox formControlName="termsAccepted" class="checkbox-field">
              I have read and understood the Explanatory Notes to the Health Declaration. This Explanation accompanies
              the form.
            </mat-checkbox>
            <mat-error
              *ngIf="applicantForm.get('termsAccepted')?.hasError('required') && applicantForm.get('termsAccepted')?.touched">
              You must accept the terms and conditions
            </mat-error>
          </div>

          <div class="form-field" style="margin-bottom: 20px;">
            <mat-checkbox formControlName="privacyAccepted" class="checkbox-field">
              I amd satisfied that i have answered all questions correctly,completely and truthfully. This also applies
              to the contents of the appendix forms if i enclose that. By doing so, I prevent the rights under this
              agreement from lapsing.</mat-checkbox>
            <mat-error
              *ngIf="applicantForm.get('privacyAccepted')?.hasError('required') && applicantForm.get('privacyAccepted')?.touched">
              You must accept the privacy policy
            </mat-error>
          </div>

          <div class="form-field">
            <mat-checkbox formControlName="marketingAccepted" class="checkbox-field">
              I am aware that the insurer will decide whether to accept my application partly on the basis of the
              medical advisors advice.I think
              that is a good thing.This applies to the insurance I am applying for now.The insurer keeps my health
              declaration for as long as it is allowed by law.
              During the time my statement is still in the insurers possession,he will also use my answers if i later
              apply for the same kind of insurance where health data is important or apply for an extension of
              insurance/
            </mat-checkbox>
          </div>

        </div>
      </div>
    </div>

  </div>

  <!-- Fixed Footer Navigation -->
  <div class="form-footer">
    <div class="footer-content">
      <div class="footer-right">
        <button class="secondaryBtn" (click)="saveDraft()">
          Save As Draft
        </button>
        <button *ngIf="currentStep > 1" (click)="previousStep()" class="primaryBtn">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
          Previous
        </button>
        <button *ngIf="currentStep < totalSteps" class="primaryBtn" (click)="nextStep()">
          Next
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" />
          </svg>
        </button>
        <button *ngIf="currentStep === totalSteps" class="primaryBtn" (click)="submitForm()" 
          >
          Submit Application
        </button>
      </div>
    </div>
  </div>
</div>
@if(preview)
{<div>



</div>}